/** The testing tools, in development and test builds only: they change the planet for everyone. */
import type { JSX } from 'react';

import { ROOM } from '@bramvasterd/terrella-rules';

import { runDev } from '@game/intents/submit';
import type { Game } from '@game/game';
import { adminOf } from '@game/planet/pockets';
import { t } from '@i18n/index';
import { showToast } from '@ui/features/toasts/toastStore';

export function Testing({ game, close }: { game: Game; close: () => void }): JSX.Element {
  const run = (command: Parameters<typeof runDev>[1], done: string): void => {
    runDev(game, command);
    close();
    showToast(done);
  };
  const s = game.store.get();
  // admin mode (rules 26): nothing costs me anything, my pockets have no end
  const admin = adminOf(s.view, s.me?.id ?? null);
  return (
    <section className="testing" aria-labelledby="testing-title">
      <h3 id="testing-title">{t('world.testing')}</h3>
      <div className="row-btns">
        <button
          type="button"
          className="btn small"
          data-dev="skip"
          onClick={() => run({ kind: 'skip' }, t('world.skip-done'))}
        >
          {t('world.skip')}
        </button>
        <button
          type="button"
          className="btn small"
          data-dev="give"
          onClick={() =>
            run(
              // every item to the room my pockets have for it (the rules cap it there anyway)
              { kind: 'give', pockets: { ...ROOM } },
              t('world.give-done'),
            )
          }
        >
          {t('world.give')}
        </button>
        <button
          type="button"
          className="btn small"
          data-dev="admin"
          aria-pressed={admin}
          onClick={() =>
            run({ kind: 'admin', on: !admin }, t(admin ? 'world.admin-off' : 'world.admin-on'))
          }
        >
          {t('world.admin')}
        </button>
        <button
          type="button"
          className="btn small"
          data-dev="test-planet"
          onClick={() => run({ kind: 'test-planet' }, t('world.test-planet-done'))}
        >
          {t('world.test-planet')}
        </button>
        <a className="btn small" href="lab.html" data-dev="lab">
          {t('world.lab')}
        </a>
      </div>
      <p className="note">{t('world.testing-note')}</p>
    </section>
  );
}
